<div id="devicedetailCard" class="control-card-white">
  <app-loading-screen #devicedetailsloader></app-loading-screen>

  <div class="control-card-header">
    <ng-container i18n="@@devicedetailseditor_title">Dettagli dispositivo</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div class="control-card-content">
    <form [formGroup]="deviceDetailsForm">
      <table class="simple-table">

        <tr>
          <td width="200px" class="text-dark" i18n="@@device_details_editor_reference">Riferimento :</td>
          <td><input id="reference-input" formControlName="reference" type="text" [(ngModel)]="deviceReference" /></td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_orderConfirmation">Order Confirmation :</td>
          <td><input id="order-confirmation-input" formControlName="orderConfirmation" type="text"
              [(ngModel)]="deviceOrderConfirmation" /></td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_phone_number">Numero di telefono:</td>
          <td><input id="phone-number-input" (keypress)="checkIfNumber($event)" formControlName="phoneNumber"
              type="text" [(ngModel)]="devicePhoneNumber" /></td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_installationDate">Data installazione:</td>
          <td> <input id="from-datepicker-input" [matDatepicker]="fromDatepicker" formControlName="installationDate"
              style="width: 350px;" [(ngModel)]="deviceInstallationDate">
            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatepicker></mat-datepicker>
          </td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_address">Indirizzo :</td>
          <td><input id="address-input" formControlName="address" type="text" [(ngModel)]="deviceAddress" /> </td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_city">Città :</td>
          <td><input id="city-input" formControlName="city" type="text" [(ngModel)]="deviceCity" /></td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_country">Stato :</td>
          <td><input id="state-input" formControlName="country" type="text" [(ngModel)]="deviceCountry" /></td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_canBusEnabled">Can bus :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel"> <input type="radio" formControlName="canBusEnabledRadio"
                  [(ngModel)]="canBusEnabledStr" name="canBusEnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="canBusEnabledRadio" [(ngModel)]="canBusEnabledStr"
                  name="canBusEnabledRadio" value="false" />
              </label>
            </div>

          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_ioEthEnabled">Scheda I/O :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel"> <input type="radio" formControlName="ioEthEnabledRadio"
                  [(ngModel)]="ioEthEnabledStr" name="ioEthEnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="ioEthEnabledRadio" [(ngModel)]="ioEthEnabledStr"
                  name="ioEthEnabledRadio" value="false" />
              </label>
            </div>
          </td>

        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_licPlateEnabled">Lettura targhe :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="licensePlateEnabledRadio" [(ngModel)]="licensePlateEnabledStr"
                  name="licensePlateEnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="licensePlateEnabledRadio" [(ngModel)]="licensePlateEnabledStr"
                  name="licensePlateEnabledRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>


        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_badge1Enabled">Lettura Badge 1 :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="badge1EnabledRadio" [(ngModel)]="badge1EnabledStr"
                  name="badge1EnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="badge1EnabledRadio" [(ngModel)]="badge1EnabledStr"
                  name="badge1EnabledRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_badge2Enabled">Lettura Badge 2 :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="badge2EnabledRadio" [(ngModel)]="badge2EnabledStr"
                  name="badge2EnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="badge2EnabledRadio" [(ngModel)]="badge2EnabledStr"
                  name="badge2EnabledRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_pin1Enabled">Lettura PIN 1 :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="pin1EnabledRadio" [(ngModel)]="pin1EnabledStr"
                  name="pin1EnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="pin1EnabledRadio" [(ngModel)]="pin1EnabledStr"
                  name="pin1EnabledRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_pin2Enabled">Lettura PIN 2 :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="pin2EnabledRadio" [(ngModel)]="pin2EnabledStr"
                  name="pin2EnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="pin2EnabledRadio" [(ngModel)]="pin2EnabledStr"
                  name="pin2EnabledRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_phoneEnabledStr">Apertura con chiamata :
          </td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="phoneEnabledStrRadio" [(ngModel)]="phoneEnabledStr"
                  name="phoneEnabledStrRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="phoneEnabledStrRadio" [(ngModel)]="phoneEnabledStr"
                  name="phoneEnabledStrRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_remoteEnabled">Apertura con radiocomando :
          </td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="remoteEnabledRadio" [(ngModel)]="remoteEnabledStr"
                  name="remoteEnabledRadio" value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="remoteEnabledRadio" [(ngModel)]="remoteEnabledStr"
                  name="remoteEnabledRadio" value="false" />
              </label>
            </div>
          </td>
        </tr>

        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_appEnabled">Apertura con App :</td>
          <td class="radioButton">
            <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="appEnabledRadio" [(ngModel)]="appEnabledStr" name="appEnabledRadio"
                  value="true">
              </label>
            </div>
            <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="appEnabledRadio" [(ngModel)]="appEnabledStr" name="appEnabledRadio"
                  value="false" />
              </label>
            </div>
          </td>
        </tr>


        <!-- START WATCHDOG STUFF -- TODO -->

        <!-- 
        <tr class="radioButtonTr" *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_watchdogEnabled">WatchDog :</td>
          <td class="radioButton">
           <ng-container i18n="@@Enable">Abilita</ng-container>
            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="watchdogEnabledRadio" [(ngModel)]="watchdogEnabledStr" name="watchdogEnabledRadio" value="true" (click)="enableTimeSetting(true);">
              </label>
            </div>
                                 <ng-container i18n="@@Disable">Disabilita</ng-container>

            <div id="radioButtonDiv">
              <label class="radioButtonLabel">
                <input type="radio" formControlName="watchdogEnabledRadio" [(ngModel)]="watchdogEnabledStr" name="watchdogEnabledRadio" value="false" (click)="enableTimeSetting(false);" >
              </label>
            </div>
          </td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService() && this.showWatchDogTimeSecValue">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_watchdogTime">Tempo : </td>
          <td> <input (keyup)="inputControl($event)" formControlName="watchDogTimeSecInput" name="watchDogTimeSecInput" [(ngModel)]="watchDogTimeSecValue" type="number" min="60" max="600"></td> 
        </tr> -->

        <!-- END WATCHDOG STUFF -- TODO -->


        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_model">Modello dispositivo :</td>
          <td>
            <select formControlName="deviceModelSelect" [(ngModel)]="deviceModel">
              <option [ngValue]="model" *ngFor="let model of models">{{model }}</option>
            </select>
          </td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_router_serial">Seriale router :</td>
          <td><input id="router-input" formControlName="router" type="text" [(ngModel)]="deviceRouterSerial" /></td>
        </tr>

        <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_systemId">systemId :</td>
          <td><input id="systemId-input" formControlName="systemId" type="text" [(ngModel)]="deviceSystemId" /></td>
        </tr>



        <!-- <tr *ngIf="this.isAdmin() || this.isService()">
          <td width="200px" class="text-dark" i18n="@@device_details_editor_notes">Note interne :</td>
          <td><input id="notes-input" formControlName="notes" type="text" [(ngModel)]="notes" /></td>
        </tr> -->

      </table>

    </form>
  </div>

  <div class="control-card-buttons">

    <a (click)="saveDeviceDetails()" class="button">
      <ng-container i18n="@@devicedetailseditor_save">Conferma</ng-container>
      <span>
        <fa-icon icon="save"></fa-icon>
      </span>
    </a>
    <a (click)="closeDialog()" class="button button-red" id="cancelButton">
      <ng-container i18n="@@devicedetailseditor_cancel">Annulla</ng-container>
      <span>
        <fa-icon icon="times"></fa-icon>
      </span>
    </a>
  </div>

  <app-loading-screen #devicedetailsloader [loading]="false"></app-loading-screen>
</div>